import { useState } from "react";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  return (
    <>
      <style>{`
        .contact-hero { background: linear-gradient(160deg,#071428,#0B1F3A,#122844); padding: 140px 5vw 80px; text-align: center; }
        .contact-hero h1 { font-family: 'Playfair Display', serif; font-size: clamp(36px,6vw,68px); font-weight: 900; color: white; margin-bottom: 18px; }
        .contact-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 60px; max-width: 1100px; margin: 0 auto; align-items: start; }
        .info-item { display: flex; gap: 16px; align-items: flex-start; margin-bottom: 28px; }
        .info-icon { width: 44px; height: 44px; border-radius: 50%; background: rgba(201,150,62,0.1); border: 1px solid rgba(201,150,62,0.2); display: flex; align-items: center; justify-content: center; font-size: 18px; flex-shrink: 0; }
        .info-label { font-size: 11px; color: #C9963E; font-weight: 600; letter-spacing: 1px; text-transform: uppercase; margin-bottom: 4px; }
        .info-val { font-size: 15px; color: var(--navy); font-weight: 500; line-height: 1.6; }
        .contact-form-card { background: white; border: 1px solid var(--border-light); padding: 40px; }
        @media (max-width: 840px) { .contact-grid { grid-template-columns: 1fr; } }
      `}</style>

      <section className="contact-hero">
        <span className="section-eyebrow" style={{ color: "#E8B96A" }}>Contact</span>
        <h1>Get in <em style={{ fontStyle: "italic", color: "#E8B96A" }}>Touch</em></h1>
        <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 17, maxWidth: 500, margin: "16px auto 0", lineHeight: 1.75 }}>We're here to answer your questions about grants, membership, or partnerships.</p>
      </section>

      <section style={{ padding: "90px 5vw", background: "var(--off-white)" }}>
        <div className="contact-grid">
          <div>
            <span className="section-eyebrow">Find Us</span>
            <h2 className="section-title" style={{ marginBottom: 36 }}>Contact Information</h2>
            {[
              ["📧","Email", <a href="mailto:revolutionaryfoundation.org.ng@gmail.com" style={{color:"var(--navy)"}}>revolutionaryfoundation.org.ng@gmail.com</a>],
              ["🌐","Social Media", <>Telegram: <a href="https://t.me/+yOAUtwNa9DMzODhk" target="_blank" rel="noreferrer" style={{color:"var(--navy)"}}>Click to Join Channel</a><br/>@RevFoundationNG</>]
            ].map(([icon, label, val]) => (
              <div className="info-item" key={label}>
                <div className="info-icon">{icon}</div>
                <div>
                  <div className="info-label">{label}</div>
                  <div className="info-val" style={{ whiteSpace: "pre-line" }}>{val}</div>
                </div>
              </div>
            ))}
          </div>
          <div className="contact-form-card">
            {sent ? (
              <div style={{ textAlign: "center", padding: "40px 0" }}>
                <div style={{ fontSize: 48, marginBottom: 16 }}>✉️</div>
                <h3 style={{ fontFamily: "'Playfair Display',serif", fontSize: 24, color: "var(--navy)", marginBottom: 10 }}>Message Sent!</h3>
                <p style={{ color: "var(--text-muted)", fontSize: 15 }}>We'll respond within 2 business days.</p>
              </div>
            ) : (
              <>
                <h3 style={{ fontFamily: "'Playfair Display',serif", fontSize: 22, color: "var(--navy)", marginBottom: 24 }}>Send a Message</h3>
                <div className="form-group"><label className="form-label">Your Name *</label><input className="form-input" placeholder="Full name" value={form.name} onChange={e => set("name", e.target.value)} /></div>
                <div className="form-group"><label className="form-label">Email Address *</label><input className="form-input" type="email" placeholder="you@org.org" value={form.email} onChange={e => set("email", e.target.value)} /></div>
                <div className="form-group"><label className="form-label">Subject</label>
                  <select className="form-select" value={form.subject} onChange={e => set("subject", e.target.value)}>
                    <option value="">Select topic...</option>
                    <option>Grant Application Inquiry</option><option>Membership Question</option><option>Partnership Proposal</option><option>Media & Press</option><option>General Inquiry</option>
                  </select>
                </div>
                <div className="form-group"><label className="form-label">Message *</label><textarea className="form-textarea" rows={5} placeholder="How can we help?" value={form.message} onChange={e => set("message", e.target.value)} /></div>
                <button className="btn-primary" style={{ width: "100%", padding: 16 }} onClick={() => setSent(true)}>Send Message →</button>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
